import React from "react";

export const DashboardIllustration: React.FC = () => (
  <svg
    width="127"
    height="98"
    viewBox="0 0 127 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2066 84.092C11.0706 83.169 10.3606 81.7632 10.3606 80.187C10.3606 77.418 12.6042 75.1602 15.3874 75.1602C18.1706 75.1602 20.4 77.418 20.4 80.2012C20.4 81.7774 19.6758 83.1832 18.554 84.1062L12.2066 84.092Z"
      fill="#72B579"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3874 75.8702C12.9976 75.8702 11.0706 77.8088 11.0706 80.187C11.0706 81.4572 11.6044 82.5936 12.4703 83.3826L18.2891 83.3956C19.1477 82.6036 19.69 81.466 19.69 80.2012C19.69 77.8049 17.7732 75.8702 15.3874 75.8702ZM9.65057 80.187C9.65057 77.0272 12.2107 74.4502 15.3874 74.4502C18.5679 74.4502 21.11 77.0311 21.11 80.2012C21.11 81.9996 20.283 83.603 19.0051 84.6545C18.8776 84.7594 18.7175 84.8166 18.5524 84.8162L12.205 84.802C12.0425 84.8016 11.885 84.7455 11.7589 84.643C10.4605 83.5881 9.65057 81.9815 9.65057 80.187Z"
      fill="#464950"
    />
    <path
      d="M81.0766 84.0352C82.7471 84.0352 84.1012 81.2824 84.1012 77.8866C84.1012 74.4908 82.7471 71.738 81.0766 71.738C79.4061 71.738 78.052 74.4908 78.052 77.8866C78.052 81.2824 79.4061 84.0352 81.0766 84.0352Z"
      fill="#AECC75"
    />
    <path
      opacity="0.51"
      d="M79.3158 77.8866C79.3158 74.933 80.3382 72.4764 81.7014 71.88C81.4884 71.7948 81.2754 71.738 81.0624 71.738C79.3868 71.738 78.0378 74.4928 78.0378 77.8866C78.0378 81.2804 79.3868 84.0352 81.0624 84.0352C81.2754 84.0352 81.4884 83.9926 81.7014 83.8932C80.3382 83.2968 79.3158 80.8402 79.3158 77.8866Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.3008 73.2255C78.8831 72.0417 79.8214 71.028 81.0766 71.028C82.3317 71.028 83.2701 72.0417 83.8524 73.2255C84.4573 74.4551 84.8112 76.104 84.8112 77.8866C84.8112 79.6692 84.4573 81.3181 83.8524 82.5477C83.2701 83.7315 82.3317 84.7452 81.0766 84.7452C79.8214 84.7452 78.8831 83.7315 78.3008 82.5477C77.6959 81.3181 77.342 79.6692 77.342 77.8866C77.342 76.104 77.6959 74.4551 78.3008 73.2255ZM79.5749 73.8523C79.0851 74.848 78.762 76.2735 78.762 77.8866C78.762 79.4998 79.0851 80.9252 79.5749 81.9209C80.0873 82.9625 80.6612 83.3252 81.0766 83.3252C81.4919 83.3252 82.0659 82.9625 82.5782 81.9209C83.068 80.9252 83.3912 79.4998 83.3912 77.8866C83.3912 76.2735 83.068 74.848 82.5782 73.8523C82.0659 72.8107 81.4919 72.448 81.0766 72.448C80.6612 72.448 80.0873 72.8107 79.5749 73.8523Z"
      fill="#464950"
    />
    <path
      d="M32.7966 60.52L32.4274 44.474H17.5174L17.1482 60.52L16.6086 84.092H33.3362L32.7966 60.52Z"
      fill="#F03A47"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.8392 65.7456H26.151V64.8936H32.8392V65.7456Z"
      fill="#DD2A40"
    />
    <path
      opacity="0.85"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9664 67.9466H21.678V67.0946H25.9664V67.9466Z"
      fill="#464950"
    />
    <path
      opacity="0.85"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.0806 69.75H30.9364V68.898H33.0806V69.75Z"
      fill="#464950"
    />
    <path
      opacity="0.85"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.7234 76.85H28.7922V75.998H30.7234V76.85Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.8392 74.3224H30.7234V73.4704H32.8392V74.3224Z"
      fill="#DD2A40"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.5612 79.903H30.2974V79.051H31.5612V79.903Z"
      fill="#DD2A40"
    />
    <path
      d="M21.2094 62.366H32.8392L32.7966 60.52H20.9538L21.2094 62.366Z"
      fill="#DD2A40"
    />
    <path
      d="M16.6086 84.092H21.394L22.0898 45.752L32.4558 45.7236L32.4274 44.474H17.5174L17.1482 60.52L16.6086 84.092Z"
      fill="#DD2A40"
    />
    <path
      d="M47.8912 53.9454C54.3691 53.9454 59.6204 48.6941 59.6204 42.2162C59.6204 35.7383 54.3691 30.487 47.8912 30.487C41.4133 30.487 36.162 35.7383 36.162 42.2162C36.162 48.6941 41.4133 53.9454 47.8912 53.9454Z"
      fill="#50B893"
    />
    <path
      opacity="0.55"
      d="M38.3204 42.2162C38.3204 36.096 43.0064 31.0692 48.9846 30.5296C48.6296 30.5012 48.2746 30.4728 47.9054 30.4728C41.4302 30.4728 36.1762 35.7268 36.1762 42.202C36.1762 48.6772 41.4302 53.9312 47.9054 53.9312C48.2746 53.9312 48.6296 53.917 48.9846 53.8744C42.9922 53.3632 38.3204 48.3364 38.3204 42.2162Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.8912 41.5062C48.2833 41.5062 48.6012 41.8241 48.6012 42.2162V51.219C48.6012 51.6111 48.2833 51.929 47.8912 51.929C47.4991 51.929 47.1812 51.6111 47.1812 51.219V42.2162C47.1812 41.8241 47.4991 41.5062 47.8912 41.5062Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.8145 43.7215C53.0184 44.0565 52.9121 44.4933 52.5771 44.6971L48.2603 47.3241C47.9253 47.528 47.4885 47.4217 47.2847 47.0867C47.0808 46.7517 47.1871 46.3149 47.5221 46.1111L51.8389 43.4841C52.1739 43.2802 52.6107 43.3865 52.8145 43.7215Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.6997 45.4529C43.9433 45.1456 44.3899 45.094 44.6971 45.3377L48.3323 48.2203C48.6396 48.4639 48.6911 48.9105 48.4475 49.2177C48.2039 49.525 47.7573 49.5766 47.45 49.3329L43.8148 46.4503C43.5076 46.2067 43.456 45.7601 43.6997 45.4529Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.452 42.2162C35.452 35.3462 41.0212 29.777 47.8912 29.777C54.7612 29.777 60.3304 35.3462 60.3304 42.2162C60.3304 49.0862 54.7612 54.6554 47.8912 54.6554C41.0212 54.6554 35.452 49.0862 35.452 42.2162ZM47.8912 31.197C41.8055 31.197 36.872 36.1304 36.872 42.2162C36.872 48.302 41.8055 53.2354 47.8912 53.2354C53.977 53.2354 58.9104 48.302 58.9104 42.2162C58.9104 36.1304 53.977 31.197 47.8912 31.197Z"
      fill="#464950"
    />
    <path
      d="M39.996 58.461C42.7409 58.461 44.966 56.2359 44.966 53.491C44.966 50.7461 42.7409 48.521 39.996 48.521C37.2511 48.521 35.026 50.7461 35.026 53.491C35.026 56.2359 37.2511 58.461 39.996 58.461Z"
      fill="#429977"
    />
    <path
      opacity="0.31"
      d="M36.8578 53.491C36.8578 51.0628 38.6044 49.0322 40.919 48.6062C40.6208 48.5494 40.3226 48.521 40.0102 48.521C37.2696 48.521 35.0402 50.7504 35.0402 53.491C35.0402 56.2316 37.2696 58.461 40.0102 58.461C40.3226 58.461 40.6208 58.4326 40.919 58.3758C38.6044 57.9498 36.8578 55.9192 36.8578 53.491Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.54 54.3202C40.7565 53.9933 41.197 53.9037 41.524 54.1202L45.642 56.8466C45.9689 57.0631 46.0585 57.5036 45.842 57.8306C45.6256 58.1575 45.185 58.2471 44.8581 58.0306L40.7401 55.3042C40.4131 55.0877 40.3235 54.6472 40.54 54.3202Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.316 53.491C34.316 50.354 36.859 47.811 39.996 47.811C43.133 47.811 45.676 50.354 45.676 53.491C45.676 56.628 43.133 59.171 39.996 59.171C36.859 59.171 34.316 56.628 34.316 53.491ZM39.996 49.231C37.6432 49.231 35.736 51.1383 35.736 53.491C35.736 55.8437 37.6432 57.751 39.996 57.751C42.3487 57.751 44.256 55.8437 44.256 53.491C44.256 51.1383 42.3487 49.231 39.996 49.231Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8076 44.4577C16.8165 44.072 17.1317 43.764 17.5174 43.764H32.4274C32.8132 43.764 33.1284 44.072 33.1372 44.4577L33.5064 60.5037L34.046 84.0758C34.0504 84.2668 33.9776 84.4516 33.844 84.5883C33.7104 84.725 33.5273 84.802 33.3362 84.802H16.6086C16.4175 84.802 16.2345 84.725 16.1009 84.5883C15.9673 84.4516 15.8944 84.2668 15.8988 84.0758L16.8076 44.4577ZM18.2113 45.184L17.3351 83.382H32.6098L32.0868 60.5363L31.7336 45.184H18.2113Z"
      fill="#464950"
    />
    <path
      d="M35.026 60.662H14.9188L17.2618 57.112H32.683L35.026 60.662Z"
      fill="#5A646D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6692 56.7209C16.8006 56.5218 17.0232 56.402 17.2618 56.402H32.683C32.9216 56.402 33.1442 56.5218 33.2756 56.7209L35.6186 60.2709C35.7625 60.4889 35.775 60.7684 35.6512 60.9985C35.5274 61.2285 35.2873 61.372 35.026 61.372H14.9188C14.6575 61.372 14.4174 61.2285 14.2936 60.9985C14.1698 60.7684 14.1823 60.4889 14.3262 60.2709L16.6692 56.7209ZM17.6439 57.822L16.2381 59.952H33.7067L32.3009 57.822H17.6439Z"
      fill="#464950"
    />
    <path
      d="M23.6234 53.562H20.0734V49.657C20.0734 48.6772 20.8686 47.882 21.8484 47.882C22.8282 47.882 23.6234 48.6772 23.6234 49.657V53.562Z"
      fill="#F4FFC5"
    />
    <path
      d="M29.8714 53.562H26.1794V49.657C26.1794 48.6772 26.9746 47.882 27.9544 47.882H28.0964C29.0762 47.882 29.8714 48.6772 29.8714 49.657V53.562Z"
      fill="#F4FFC5"
    />
    <path
      d="M21.8484 47.882C20.8686 47.882 20.0734 48.6772 20.0734 49.657V51.219C20.0734 50.2392 20.8686 49.444 21.8484 49.444C22.8282 49.444 23.6234 50.2392 23.6234 51.219V49.657C23.6234 48.6772 22.8282 47.882 21.8484 47.882Z"
      fill="#B7C391"
    />
    <path
      d="M28.0964 47.882H27.9544C26.9746 47.882 26.1794 48.6772 26.1794 49.657V51.219C26.1794 50.2392 26.9746 49.444 27.9544 49.444H28.0964C29.0762 49.444 29.8714 50.2392 29.8714 51.219V49.657C29.8714 48.6772 29.0762 47.882 28.0964 47.882Z"
      fill="#B7C391"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8484 48.592C21.2607 48.592 20.7834 49.0693 20.7834 49.657V52.852H22.9134V49.657C22.9134 49.0693 22.4361 48.592 21.8484 48.592ZM19.3634 49.657C19.3634 48.2851 20.4765 47.172 21.8484 47.172C23.2203 47.172 24.3334 48.2851 24.3334 49.657V53.562C24.3334 53.9541 24.0155 54.272 23.6234 54.272H20.0734C19.6813 54.272 19.3634 53.9541 19.3634 53.562V49.657Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.9544 48.592C27.3667 48.592 26.8894 49.0693 26.8894 49.657V52.852H29.1614V49.657C29.1614 49.0693 28.6841 48.592 28.0964 48.592H27.9544ZM25.4694 49.657C25.4694 48.2851 26.5825 47.172 27.9544 47.172H28.0964C29.4683 47.172 30.5814 48.2851 30.5814 49.657V53.562C30.5814 53.9541 30.2635 54.272 29.8714 54.272H26.1794C25.7873 54.272 25.4694 53.9541 25.4694 53.562V49.657Z"
      fill="#464950"
    />
    <path
      d="M34.2024 44.474H15.7424L24.9724 35.4712L34.2024 44.474Z"
      fill="#5A646D"
    />
    <path
      d="M24.9724 35.4712L22.2886 44.474H15.7424L24.9724 35.4712Z"
      fill="#4C555C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4766 34.9629C24.7524 34.694 25.1924 34.694 25.4681 34.9629L34.6981 43.9657C34.9049 44.1674 34.9689 44.4741 34.86 44.7416C34.7512 45.0091 34.4912 45.184 34.2024 45.184H15.7424C15.4536 45.184 15.1936 45.0091 15.0847 44.7416C14.9759 44.4741 15.0399 44.1674 15.2466 43.9657L24.4766 34.9629ZM24.9724 36.463L17.4871 43.764H32.4576L24.9724 36.463Z"
      fill="#464950"
    />
    <path d="M29.0052 69.75H20.9538V84.092H29.0052V69.75Z" fill="#F4FFC5" />
    <path d="M29.0052 69.75H20.9538V71.5676H29.0052V69.75Z" fill="#B7C391" />
    <path d="M22.246 69.75H21.0958V84.092H22.246V69.75Z" fill="#B7C391" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2438 69.75C20.2438 69.3579 20.5617 69.04 20.9538 69.04H29.0052C29.3973 69.04 29.7152 69.3579 29.7152 69.75V84.092C29.7152 84.4841 29.3973 84.802 29.0052 84.802H20.9538C20.5617 84.802 20.2438 84.4841 20.2438 84.092V69.75ZM21.6638 70.46V83.382H28.2952V70.46H21.6638Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1656 70.7956C22.4508 70.665 22.7879 70.7902 22.9186 71.0754L28.059 82.2934C28.1896 82.5786 28.0644 82.9157 27.7792 83.0464C27.494 83.1771 27.1569 83.0518 27.0262 82.7666L21.8858 71.5486C21.7551 71.2634 21.8804 70.9263 22.1656 70.7956Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.7792 70.7956C28.0644 70.9263 28.1896 71.2634 28.059 71.5486L22.9186 82.7666C22.7879 83.0518 22.4508 83.1771 22.1656 83.0464C21.8804 82.9157 21.7551 82.5786 21.8858 82.2934L27.0262 71.0754C27.1569 70.7902 27.494 70.665 27.7792 70.7956Z"
      fill="#464950"
    />
    <path
      d="M72.0028 50.9208L59.1802 44.474L46.3576 50.9208L42.1828 58.248V83.7796H76.1776V58.248L72.0028 50.9208Z"
      fill="#F03A47"
    />
    <path
      d="M72.0028 50.9208L59.1802 44.474L46.3576 50.9208L42.1828 58.248V83.7796H76.1776V58.248L72.0028 50.9208Z"
      fill="#F03A47"
    />
    <path
      opacity="0.92"
      d="M43.6312 64.4108H42.1828V83.95H43.6312V64.4108Z"
      fill="#DD2A40"
    />
    <path
      opacity="0.92"
      d="M59.6062 44.474L46.7836 50.9208L42.6088 58.248V65.6888L49.439 54.4282L59.6062 49.3162L69.7734 54.4282L76.6036 65.6888V58.248L72.4288 50.9208L59.6062 44.474Z"
      fill="#DD2A40"
    />
    <g opacity="0.4">
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.1266 50.438C49.1266 50.3204 49.222 50.225 49.3396 50.225H69.0208C69.1384 50.225 69.2338 50.3204 69.2338 50.438C69.2338 50.5556 69.1384 50.651 69.0208 50.651H49.3396C49.222 50.651 49.1266 50.5556 49.1266 50.438Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.244 52.994C46.244 52.8764 46.3394 52.781 46.457 52.781H71.9034C72.0211 52.781 72.1164 52.8764 72.1164 52.994C72.1164 53.1116 72.0211 53.207 71.9034 53.207H46.457C46.3394 53.207 46.244 53.1116 46.244 52.994Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.6394 55.55C44.6394 55.4324 44.7348 55.337 44.8524 55.337H73.508C73.6256 55.337 73.721 55.4324 73.721 55.55C73.721 55.6676 73.6256 55.763 73.508 55.763H44.8524C44.7348 55.763 44.6394 55.6676 44.6394 55.55Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.0348 58.106C43.0348 57.9884 43.1302 57.893 43.2478 57.893H75.1126C75.2302 57.893 75.3256 57.9884 75.3256 58.106C75.3256 58.2236 75.2302 58.319 75.1126 58.319H43.2478C43.1302 58.319 43.0348 58.2236 43.0348 58.106Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 60.662C41.9698 60.5444 42.0652 60.449 42.1828 60.449H76.1776C76.2952 60.449 76.3906 60.5444 76.3906 60.662C76.3906 60.7796 76.2952 60.875 76.1776 60.875H42.1828C42.0652 60.875 41.9698 60.7796 41.9698 60.662Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 63.218C41.9698 63.1004 42.0652 63.005 42.1828 63.005H76.1776C76.2952 63.005 76.3906 63.1004 76.3906 63.218C76.3906 63.3356 76.2952 63.431 76.1776 63.431H42.1828C42.0652 63.431 41.9698 63.3356 41.9698 63.218Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 65.774C41.9698 65.6564 42.0652 65.561 42.1828 65.561H76.1776C76.2952 65.561 76.3906 65.6564 76.3906 65.774C76.3906 65.8916 76.2952 65.987 76.1776 65.987H42.1828C42.0652 65.987 41.9698 65.8916 41.9698 65.774Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 68.33C41.9698 68.2124 42.0652 68.117 42.1828 68.117H76.1776C76.2952 68.117 76.3906 68.2124 76.3906 68.33C76.3906 68.4476 76.2952 68.543 76.1776 68.543H42.1828C42.0652 68.543 41.9698 68.4476 41.9698 68.33Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 70.886C41.9698 70.7684 42.0652 70.673 42.1828 70.673H76.1776C76.2952 70.673 76.3906 70.7684 76.3906 70.886C76.3906 71.0036 76.2952 71.099 76.1776 71.099H42.1828C42.0652 71.099 41.9698 71.0036 41.9698 70.886Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 73.442C41.9698 73.3244 42.0652 73.229 42.1828 73.229H76.1776C76.2952 73.229 76.3906 73.3244 76.3906 73.442C76.3906 73.5596 76.2952 73.655 76.1776 73.655H42.1828C42.0652 73.655 41.9698 73.5596 41.9698 73.442Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 75.998C41.9698 75.8804 42.0652 75.785 42.1828 75.785H76.1776C76.2952 75.785 76.3906 75.8804 76.3906 75.998C76.3906 76.1156 76.2952 76.211 76.1776 76.211H42.1828C42.0652 76.211 41.9698 76.1156 41.9698 75.998Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 78.554C41.9698 78.4364 42.0652 78.341 42.1828 78.341H76.1776C76.2952 78.341 76.3906 78.4364 76.3906 78.554C76.3906 78.6716 76.2952 78.767 76.1776 78.767H42.1828C42.0652 78.767 41.9698 78.6716 41.9698 78.554Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 81.11C41.9698 80.9924 42.0652 80.897 42.1828 80.897H76.1776C76.2952 80.897 76.3906 80.9924 76.3906 81.11C76.3906 81.2276 76.2952 81.323 76.1776 81.323H42.1828C42.0652 81.323 41.9698 81.2276 41.9698 81.11Z"
          fill="#464950"
        />
      </g>
    </g>
    <path
      d="M76.1776 64.4108H42.1828V65.8024H76.1776V64.4108Z"
      fill="#DD2A40"
    />
    <g opacity="0.97">
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.1266 50.864C49.1266 50.7464 49.222 50.651 49.3396 50.651H69.0208C69.1384 50.651 69.2338 50.7464 69.2338 50.864C69.2338 50.9816 69.1384 51.077 69.0208 51.077H49.3396C49.222 51.077 49.1266 50.9816 49.1266 50.864Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.244 53.42C46.244 53.3024 46.3394 53.207 46.457 53.207H71.9034C72.0211 53.207 72.1164 53.3024 72.1164 53.42C72.1164 53.5376 72.0211 53.633 71.9034 53.633H46.457C46.3394 53.633 46.244 53.5376 46.244 53.42Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.6394 55.976C44.6394 55.8584 44.7348 55.763 44.8524 55.763H73.508C73.6256 55.763 73.721 55.8584 73.721 55.976C73.721 56.0936 73.6256 56.189 73.508 56.189H44.8524C44.7348 56.189 44.6394 56.0936 44.6394 55.976Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.0348 58.532C43.0348 58.4144 43.1302 58.319 43.2478 58.319H75.1126C75.2302 58.319 75.3256 58.4144 75.3256 58.532C75.3256 58.6496 75.2302 58.745 75.1126 58.745H43.2478C43.1302 58.745 43.0348 58.6496 43.0348 58.532Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 61.088C41.9698 60.9704 42.0652 60.875 42.1828 60.875H76.1776C76.2952 60.875 76.3906 60.9704 76.3906 61.088C76.3906 61.2056 76.2952 61.301 76.1776 61.301H42.1828C42.0652 61.301 41.9698 61.2056 41.9698 61.088Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 63.644C41.9698 63.5264 42.0652 63.431 42.1828 63.431H76.1776C76.2952 63.431 76.3906 63.5264 76.3906 63.644C76.3906 63.7616 76.2952 63.857 76.1776 63.857H42.1828C42.0652 63.857 41.9698 63.7616 41.9698 63.644Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 66.2C41.9698 66.0824 42.0652 65.987 42.1828 65.987H76.1776C76.2952 65.987 76.3906 66.0824 76.3906 66.2C76.3906 66.3176 76.2952 66.413 76.1776 66.413H42.1828C42.0652 66.413 41.9698 66.3176 41.9698 66.2Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 68.756C41.9698 68.6384 42.0652 68.543 42.1828 68.543H76.1776C76.2952 68.543 76.3906 68.6384 76.3906 68.756C76.3906 68.8736 76.2952 68.969 76.1776 68.969H42.1828C42.0652 68.969 41.9698 68.8736 41.9698 68.756Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 71.312C41.9698 71.1944 42.0652 71.099 42.1828 71.099H76.1776C76.2952 71.099 76.3906 71.1944 76.3906 71.312C76.3906 71.4296 76.2952 71.525 76.1776 71.525H42.1828C42.0652 71.525 41.9698 71.4296 41.9698 71.312Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 73.868C41.9698 73.7504 42.0652 73.655 42.1828 73.655H76.1776C76.2952 73.655 76.3906 73.7504 76.3906 73.868C76.3906 73.9856 76.2952 74.081 76.1776 74.081H42.1828C42.0652 74.081 41.9698 73.9856 41.9698 73.868Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 76.424C41.9698 76.3064 42.0652 76.211 42.1828 76.211H76.1776C76.2952 76.211 76.3906 76.3064 76.3906 76.424C76.3906 76.5416 76.2952 76.637 76.1776 76.637H42.1828C42.0652 76.637 41.9698 76.5416 41.9698 76.424Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 78.98C41.9698 78.8624 42.0652 78.767 42.1828 78.767H76.1776C76.2952 78.767 76.3906 78.8624 76.3906 78.98C76.3906 79.0976 76.2952 79.193 76.1776 79.193H42.1828C42.0652 79.193 41.9698 79.0976 41.9698 78.98Z"
          fill="#464950"
        />
      </g>
      <g opacity="0.97">
        <path
          opacity="0.97"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9698 81.536C41.9698 81.4184 42.0652 81.323 42.1828 81.323H76.1776C76.2952 81.323 76.3906 81.4184 76.3906 81.536C76.3906 81.6536 76.2952 81.749 76.1776 81.749H42.1828C42.0652 81.749 41.9698 81.6536 41.9698 81.536Z"
          fill="#464950"
        />
      </g>
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.8613 43.8397C59.0619 43.7388 59.2985 43.7388 59.4991 43.8397L72.3217 50.2865C72.4467 50.3493 72.5504 50.4477 72.6197 50.5693L76.7945 57.8965C76.8555 58.0036 76.8876 58.1247 76.8876 58.248V83.7796C76.8876 84.1717 76.5697 84.4896 76.1776 84.4896H42.1828C41.7907 84.4896 41.4728 84.1717 41.4728 83.7796V58.248C41.4728 58.1247 41.5049 58.0036 41.5659 57.8965L45.7407 50.5693C45.81 50.4477 45.9136 50.3493 46.0387 50.2865L58.8613 43.8397ZM46.8682 51.4587L42.8928 58.4361V83.0696H75.4676V58.4361L71.4921 51.4587L59.1802 45.2687L46.8682 51.4587Z"
      fill="#464950"
    />
    <path d="M59.1802 70.389H49.3396V83.7796H59.1802V70.389Z" fill="#F4FFC5" />
    <path d="M59.1802 70.389H49.3396V83.7796H59.1802V70.389Z" fill="#F4FFC5" />
    <path d="M59.1802 70.389H49.3396V72.306H59.1802V70.389Z" fill="#B7C391" />
    <path d="M50.646 70.389H49.3396V83.6234H50.646V70.389Z" fill="#B7C391" />
    <path d="M69.0208 70.389H59.1802V83.7796H69.0208V70.389Z" fill="#F4FFC5" />
    <path d="M69.0208 70.389H59.1802V72.306H69.0208V70.389Z" fill="#B7C391" />
    <path d="M60.4866 70.389H59.1802V83.6234H60.4866V70.389Z" fill="#B7C391" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.6296 70.389C48.6296 69.9969 48.9475 69.679 49.3396 69.679H59.1802C59.5723 69.679 59.8902 69.9969 59.8902 70.389V83.7796C59.8902 84.1717 59.5723 84.4896 59.1802 84.4896H49.3396C48.9475 84.4896 48.6296 84.1717 48.6296 83.7796V70.389ZM50.0496 71.099V83.0696H58.4702V71.099H50.0496Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.4702 70.389C58.4702 69.9969 58.7881 69.679 59.1802 69.679H69.0208C69.4129 69.679 69.7308 69.9969 69.7308 70.389V83.7796C69.7308 84.1717 69.4129 84.4896 69.0208 84.4896H59.1802C58.7881 84.4896 58.4702 84.1717 58.4702 83.7796V70.389ZM59.8902 71.099V83.0696H68.3108V71.099H59.8902Z"
      fill="#464950"
    />
    <path d="M63.4402 52.994H54.9202V61.514H63.4402V52.994Z" fill="#F4FFC5" />
    <path d="M63.4402 52.994H54.9202V61.514H63.4402V52.994Z" fill="#F4FFC5" />
    <path d="M63.4402 52.994H54.9202V54.485H63.4402V52.994Z" fill="#B7C391" />
    <path d="M63.4402 57.325H54.9202V58.461H63.4402V57.325Z" fill="#B7C391" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.2102 52.994C54.2102 52.6019 54.5281 52.284 54.9202 52.284H63.4402C63.8323 52.284 64.1502 52.6019 64.1502 52.994V61.514C64.1502 61.9061 63.8323 62.224 63.4402 62.224H54.9202C54.5281 62.224 54.2102 61.9061 54.2102 61.514V52.994ZM55.6302 53.704V60.804H62.7302V53.704H55.6302Z"
      fill="#464950"
    />
    <path
      d="M78.8188 62.863L76.845 63.9848L70.3698 52.639L59.1802 47.0158L47.9906 52.639L41.5154 63.9848L39.5416 62.863L46.3576 50.9208L59.1802 44.474L72.0028 50.9208L78.8188 62.863Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.8613 43.8397C59.0619 43.7388 59.2985 43.7388 59.4991 43.8397L72.3217 50.2865C72.4466 50.3492 72.5502 50.4475 72.6194 50.5689L79.4354 62.5111C79.5289 62.6748 79.5534 62.869 79.5035 63.0508C79.4537 63.2326 79.3335 63.3871 79.1696 63.4803L77.1958 64.6021C76.8553 64.7956 76.4225 64.6769 76.2284 64.3367L69.8594 53.1771L59.1802 47.8104L48.501 53.1771L42.1321 64.3367C41.9379 64.6769 41.5051 64.7956 41.1646 64.6021L39.1908 63.4803C39.0269 63.3871 38.9068 63.2326 38.8569 63.0508C38.807 62.869 38.8315 62.6748 38.925 62.5111L45.741 50.5689C45.8103 50.4475 45.9138 50.3492 46.0387 50.2865L58.8613 43.8397ZM46.868 51.4589L40.5108 62.5972L41.2501 63.0173L47.374 52.2871C47.4433 52.1657 47.5469 52.0674 47.6718 52.0046L58.8614 46.3814C59.062 46.2806 59.2984 46.2806 59.499 46.3814L70.6886 52.0046C70.8135 52.0674 70.9172 52.1657 70.9865 52.2871L77.1103 63.0173L77.8496 62.5972L71.4924 51.4589L59.1802 45.2687L46.868 51.4589Z"
      fill="#464950"
    />
    <path
      d="M97.3072 73.2148C100.946 73.2148 103.896 67.8807 103.896 61.301C103.896 54.7212 100.946 49.3872 97.3072 49.3872C93.6683 49.3872 90.7184 54.7212 90.7184 61.301C90.7184 67.8807 93.6683 73.2148 97.3072 73.2148Z"
      fill="#AECC75"
    />
    <path
      opacity="0.51"
      d="M92.4792 61.443C92.4792 55.2234 95.1204 50.1256 98.4716 49.586C98.0882 49.4582 97.7048 49.3872 97.293 49.3872C93.6578 49.3872 90.7042 54.7264 90.7042 61.301C90.7042 67.8756 93.6578 73.2148 97.293 73.2148C97.4918 73.2148 97.6906 73.2006 97.8894 73.158C94.8222 72.164 92.4792 67.2934 92.4792 61.443Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.0269 52.533C93.274 50.278 95.1112 48.6772 97.3072 48.6772C99.5032 48.6772 101.34 50.278 102.587 52.533C103.848 54.8128 104.606 57.9142 104.606 61.301C104.606 64.6878 103.848 67.7891 102.587 70.0689C101.34 72.324 99.5032 73.9248 97.3072 73.9248C95.1112 73.9248 93.274 72.324 92.0269 70.0689C90.7661 67.7891 90.0084 64.6878 90.0084 61.301C90.0084 57.9142 90.7661 54.8128 92.0269 52.533ZM93.2695 53.2203C92.1457 55.2524 91.4284 58.108 91.4284 61.301C91.4284 64.4939 92.1457 67.3495 93.2695 69.3817C94.4071 71.4386 95.8643 72.5048 97.3072 72.5048C98.75 72.5048 100.207 71.4386 101.345 69.3817C102.469 67.3495 103.186 64.4939 103.186 61.301C103.186 58.108 102.469 55.2524 101.345 53.2203C100.207 51.1634 98.7501 50.0972 97.3072 50.0972C95.8643 50.0972 94.407 51.1634 93.2695 53.2203Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.3072 58.2054C97.6993 58.2054 98.0172 58.5233 98.0172 58.9154V83.7796C98.0172 84.1717 97.6993 84.4896 97.3072 84.4896C96.9151 84.4896 96.5972 84.1717 96.5972 83.7796V58.9154C96.5972 58.5233 96.9151 58.2054 97.3072 58.2054Z"
      fill="#464950"
    />
    <path
      d="M119.686 50.509C121.007 55.124 121.021 59.4408 119.473 62.8204C117.982 66.1716 114.944 68.5998 111.337 68.5714C107.716 68.5998 104.677 66.1716 103.2 62.8204C101.667 59.4266 101.667 55.1098 102.987 50.509C106.04 41.2932 108.27 33.54 111.337 33.54C114.404 33.5258 116.633 41.2932 119.686 50.509Z"
      fill="#72B579"
    />
    <path
      opacity="0.51"
      d="M108.17 62.6642C108.805 62.6642 109.32 62.1493 109.32 61.514C109.32 60.8788 108.805 60.3638 108.17 60.3638C107.535 60.3638 107.02 60.8788 107.02 61.514C107.02 62.1493 107.535 62.6642 108.17 62.6642Z"
      fill="#464950"
    />
    <path
      opacity="0.38"
      d="M105.401 62.792C103.782 59.242 103.797 54.698 105.188 49.8558C107.574 42.5854 109.462 35.457 111.55 34.2358C111.465 34.2216 111.422 33.5116 111.337 33.5116C108.27 33.5116 106.04 41.279 102.987 50.4806C101.667 55.0956 101.652 59.4124 103.2 62.792C104.691 66.1432 107.73 68.5714 111.337 68.543C111.493 68.543 111.635 68.543 111.791 68.5288C108.965 67.8188 106.651 65.6178 105.401 62.792Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M112.949 35.3298C112.311 34.5223 111.78 34.248 111.34 34.25L111.337 34.25C110.895 34.25 110.363 34.5273 109.725 35.3356C109.095 36.132 108.463 37.3202 107.809 38.8479C106.745 41.3355 105.681 44.5813 104.493 48.2037C104.224 49.0242 103.949 49.8639 103.666 50.7186C102.378 55.2147 102.407 59.3412 103.847 62.528L103.85 62.5341C105.24 65.6886 108.056 67.8871 111.331 67.8614C111.335 67.8614 111.339 67.8614 111.342 67.8614C114.602 67.8871 117.42 65.6893 118.825 62.5318L118.828 62.5248C120.279 59.3556 120.297 55.2318 119.008 50.7183C118.722 49.8548 118.444 49.0064 118.172 48.1777C116.988 44.5646 115.926 41.3257 114.864 38.8424C114.21 37.3138 113.578 36.1253 112.949 35.3298ZM119.531 47.7639C119.802 48.5907 120.078 49.4332 120.36 50.2857C120.362 50.2905 120.363 50.2953 120.365 50.3001C120.366 50.3046 120.368 50.3091 120.369 50.3137C121.717 55.0232 121.762 59.5264 120.121 63.1126C118.544 66.654 115.287 69.31 111.337 69.2814C107.373 69.31 104.115 66.6545 102.552 63.1098C100.928 59.5127 100.956 55.0119 102.305 50.3131C102.307 50.3039 102.31 50.2948 102.313 50.2857C102.593 49.4417 102.866 48.6077 103.135 47.7891C104.323 44.1634 105.412 40.8399 106.504 38.2893C107.173 36.7267 107.864 35.4006 108.61 34.4553C109.348 33.5223 110.244 32.8307 111.335 32.83C112.428 32.8256 113.326 33.5166 114.063 34.4491C114.81 35.394 115.501 36.7206 116.17 38.2841C117.259 40.8303 118.346 44.147 119.531 47.7639Z"
      fill="#464950"
    />
    <path
      d="M32.3706 83.7796C32.3706 81.6922 34.0604 80.0024 36.1478 80.0024C38.2352 80.0024 39.925 81.6922 39.925 83.7796H32.3706Z"
      fill="#AECC75"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.163 83.0696H39.1326C38.8126 81.7172 37.5986 80.7124 36.1478 80.7124C34.6969 80.7124 33.4829 81.7172 33.163 83.0696ZM31.6606 83.7796C31.6606 81.3001 33.6683 79.2924 36.1478 79.2924C38.6273 79.2924 40.635 81.3001 40.635 83.7796C40.635 84.1717 40.3171 84.4896 39.925 84.4896H32.3706C31.9785 84.4896 31.6606 84.1717 31.6606 83.7796Z"
      fill="#464950"
    />
    <path
      d="M5.03564 84.0636C5.03564 81.9762 6.7254 80.2864 8.8128 80.2864C10.9002 80.2864 12.59 81.9762 12.59 84.0636H5.03564Z"
      fill="#AECC75"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82804 83.3536H11.7976C11.4776 82.0012 10.2636 80.9964 8.81278 80.9964C7.36195 80.9964 6.14796 82.0012 5.82804 83.3536ZM4.32562 84.0636C4.32562 81.5841 6.33325 79.5764 8.81278 79.5764C11.2923 79.5764 13.3 81.5841 13.3 84.0636C13.3 84.4557 12.9821 84.7736 12.59 84.7736H5.03562C4.6435 84.7736 4.32562 84.4557 4.32562 84.0636Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.4206 63.9848C71.4206 63.5927 71.7385 63.2748 72.1306 63.2748H76.4616C76.8537 63.2748 77.1716 63.5927 77.1716 63.9848C77.1716 64.3769 76.8537 64.6948 76.4616 64.6948H72.1306C71.7385 64.6948 71.4206 64.3769 71.4206 63.9848Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.544 63.9848C67.544 63.5927 67.8619 63.2748 68.254 63.2748H69.958C70.3501 63.2748 70.668 63.5927 70.668 63.9848C70.668 64.3769 70.3501 64.6948 69.958 64.6948H68.254C67.8619 64.6948 67.544 64.3769 67.544 63.9848Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.8054 63.9848C40.8054 63.5927 41.1233 63.2748 41.5154 63.2748H66.3654C66.7575 63.2748 67.0754 63.5927 67.0754 63.9848C67.0754 64.3769 66.7575 64.6948 66.3654 64.6948H41.5154C41.1233 64.6948 40.8054 64.3769 40.8054 63.9848Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.1802 52.71C59.4155 52.71 59.6062 52.9007 59.6062 53.136V61.7554C59.6062 61.9907 59.4155 62.1814 59.1802 62.1814C58.9449 62.1814 58.7542 61.9907 58.7542 61.7554V53.136C58.7542 52.9007 58.9449 52.71 59.1802 52.71Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.7782 57.254C54.7782 57.0187 54.9689 56.828 55.2042 56.828H63.1562C63.3915 56.828 63.5822 57.0187 63.5822 57.254C63.5822 57.4893 63.3915 57.68 63.1562 57.68H55.2042C54.9689 57.68 54.7782 57.4893 54.7782 57.254Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.7719 71.8329C51.0332 71.6593 51.3858 71.7304 51.5593 71.9917L57.9067 81.5483C58.0803 81.8097 58.0092 82.1622 57.7478 82.3358C57.4865 82.5093 57.134 82.4382 56.9604 82.1769L50.613 72.6203C50.4395 72.359 50.5106 72.0064 50.7719 71.8329Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.7478 71.8329C58.0092 72.0064 58.0803 72.359 57.9067 72.6203L51.5593 82.1769C51.3858 82.4382 51.0332 82.5093 50.7719 82.3358C50.5106 82.1622 50.4395 81.8097 50.613 81.5483L56.9604 71.9917C57.134 71.7304 57.4865 71.6593 57.7478 71.8329Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.6126 71.8329C60.8739 71.6593 61.2264 71.7304 61.4 71.9917L67.7474 81.5483C67.9209 81.8097 67.8498 82.1622 67.5885 82.3358C67.3272 82.5093 66.9746 82.4382 66.8011 82.1769L60.4537 72.6203C60.2801 72.359 60.3513 72.0064 60.6126 71.8329Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.5885 71.8329C67.8498 72.0064 67.9209 72.359 67.7474 72.6203L61.4 82.1769C61.2264 82.4382 60.8739 82.5093 60.6126 82.3358C60.3513 82.1622 60.2801 81.8097 60.4537 81.5483L66.8011 71.9917C66.9746 71.7304 67.3272 71.6593 67.5885 71.8329Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.855 96.8436C27.855 96.4515 28.1729 96.1336 28.565 96.1336H48.3172C48.7093 96.1336 49.0272 96.4515 49.0272 96.8436C49.0272 97.2357 48.7093 97.5536 48.3172 97.5536H28.565C28.1729 97.5536 27.855 97.2357 27.855 96.8436Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.672 96.8436C22.672 96.4515 22.9899 96.1336 23.382 96.1336H25.441C25.8331 96.1336 26.151 96.4515 26.151 96.8436C26.151 97.2357 25.8331 97.5536 25.441 97.5536H23.382C22.9899 97.5536 22.672 97.2357 22.672 96.8436Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.7234 92.9954C30.7234 92.7209 30.9459 92.4984 31.2204 92.4984H48.3172C48.5917 92.4984 48.8142 92.7209 48.8142 92.9954V93.9894C48.8142 94.2639 48.5917 94.4864 48.3172 94.4864H31.2204C30.9459 94.4864 30.7234 94.2639 30.7234 93.9894V92.9954Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.7234 89.701C30.7234 89.4265 30.9459 89.204 31.2204 89.204H48.3172C48.5917 89.204 48.8142 89.4265 48.8142 89.701V90.695C48.8142 90.9695 48.5917 91.192 48.3172 91.192H31.2204C30.9459 91.192 30.7234 90.9695 30.7234 90.695V89.701Z"
      fill="#464950"
    />
    <path
      d="M41.3166 96.8436H38.6186V86.4776L39.9676 84.9724L41.3166 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M39.8966 87.1876L41.0752 85.8812L40.3936 85.1144L39.0446 86.6196V96.9856H39.8966V87.1876Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.9676 84.2624C40.1694 84.2624 40.3616 84.3483 40.4963 84.4986L41.8453 86.0038C41.962 86.134 42.0266 86.3027 42.0266 86.4776V96.8436C42.0266 97.2357 41.7087 97.5536 41.3166 97.5536H38.6186C38.2264 97.5536 37.9086 97.2357 37.9086 96.8436V86.4776C37.9086 86.3027 37.9731 86.134 38.0898 86.0038L39.4388 84.4986C39.5735 84.3483 39.7658 84.2624 39.9676 84.2624ZM39.3286 86.7492V96.1336H40.6066V86.7492L39.9676 86.0362L39.3286 86.7492Z"
      fill="#464950"
    />
    <path
      d="M46.7552 96.8436H44.0572V86.4776L45.4062 84.9724L46.7552 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M45.3352 87.1876L46.4996 85.8812L45.8322 85.1144L44.4832 86.6196V96.9856H45.3352V87.1876Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.4062 84.2624C45.608 84.2624 45.8003 84.3483 45.935 84.4986L47.284 86.0038C47.4007 86.134 47.4652 86.3027 47.4652 86.4776V96.8436C47.4652 97.2357 47.1474 97.5536 46.7552 97.5536H44.0572C43.6651 97.5536 43.3472 97.2357 43.3472 96.8436V86.4776C43.3472 86.3027 43.4118 86.134 43.5285 86.0038L44.8775 84.4986C45.0122 84.3483 45.2044 84.2624 45.4062 84.2624ZM44.7672 86.7492V96.1336H46.0452V86.7492L45.4062 86.0362L44.7672 86.7492Z"
      fill="#464950"
    />
    <path
      d="M35.8212 96.8436H33.1232V86.4776L34.4722 84.9724L35.8212 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      d="M35.8212 96.8436H33.1232V86.4776L34.4722 84.9724L35.8212 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M34.4012 87.1876L35.5798 85.8812L34.8982 85.1144L33.5492 86.6196V96.9856H34.4012V87.1876Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.4722 84.2624C34.674 84.2624 34.8663 84.3483 35.0009 84.4986L36.3499 86.0038C36.4667 86.134 36.5312 86.3027 36.5312 86.4776V96.8436C36.5312 97.2357 36.2133 97.5536 35.8212 97.5536H33.1232C32.7311 97.5536 32.4132 97.2357 32.4132 96.8436V86.4776C32.4132 86.3027 32.4778 86.134 32.5945 86.0038L33.9435 84.4986C34.0782 84.3483 34.2704 84.2624 34.4722 84.2624ZM33.8332 86.7492V96.1336H35.1112V86.7492L34.4722 86.0362L33.8332 86.7492Z"
      fill="#464950"
    />
    <path
      opacity="0.76"
      d="M50.9868 37.5444C51.5044 37.5444 51.924 37.1248 51.924 36.6072C51.924 36.0896 51.5044 35.67 50.9868 35.67C50.4692 35.67 50.0496 36.0896 50.0496 36.6072C50.0496 37.1248 50.4692 37.5444 50.9868 37.5444Z"
      fill="#464950"
    />
    <path
      opacity="0.76"
      d="M44.9802 37.2178C45.9448 37.2178 46.7268 36.4358 46.7268 35.4712C46.7268 34.5066 45.9448 33.7246 44.9802 33.7246C44.0156 33.7246 43.2336 34.5066 43.2336 35.4712C43.2336 36.4358 44.0156 37.2178 44.9802 37.2178Z"
      fill="#464950"
    />
    <path
      opacity="0.76"
      d="M44.256 42.7558C44.5541 42.7558 44.7956 42.5143 44.7956 42.2162C44.7956 41.9181 44.5541 41.6766 44.256 41.6766C43.9581 41.6766 43.7164 41.9181 43.7164 42.2162C43.7164 42.5143 43.9581 42.7558 44.256 42.7558Z"
      fill="#464950"
    />
    <path
      opacity="0.67"
      d="M40.6776 42.1736C41.3051 42.1736 41.8136 41.665 41.8136 41.0376C41.8136 40.4102 41.3051 39.9016 40.6776 39.9016C40.0503 39.9016 39.5416 40.4102 39.5416 41.0376C39.5416 41.665 40.0503 42.1736 40.6776 42.1736Z"
      fill="#464950"
    />
    <path
      opacity="0.67"
      d="M46.9114 40.1288C47.4525 40.1288 47.8912 39.69 47.8912 39.149C47.8912 38.6078 47.4525 38.1692 46.9114 38.1692C46.3704 38.1692 45.9316 38.6078 45.9316 39.149C45.9316 39.69 46.3704 40.1288 46.9114 40.1288Z"
      fill="#464950"
    />
    <path
      opacity="0.67"
      d="M54.977 41.9464C55.228 41.9464 55.4314 41.7429 55.4314 41.492C55.4314 41.2411 55.228 41.0376 54.977 41.0376C54.7261 41.0376 54.5226 41.2411 54.5226 41.492C54.5226 41.7429 54.7261 41.9464 54.977 41.9464Z"
      fill="#464950"
    />
    <path
      d="M118.877 51.9716C120.665 51.9716 122.115 50.5221 122.115 48.734C122.115 46.9459 120.665 45.4964 118.877 45.4964C117.089 45.4964 115.639 46.9459 115.639 48.734C115.639 50.5221 117.089 51.9716 118.877 51.9716Z"
      fill="#62A366"
    />
    <path
      opacity="0.3"
      d="M117.372 48.734C117.372 47.172 118.479 45.8656 119.956 45.5532C119.743 45.5106 119.53 45.4822 119.303 45.4822C117.514 45.4822 116.065 46.9306 116.065 48.7198C116.065 50.509 117.514 51.9574 119.303 51.9574C119.53 51.9574 119.743 51.929 119.956 51.8864C118.479 51.6024 117.372 50.296 117.372 48.734Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.929 48.734C114.929 46.5538 116.697 44.7864 118.877 44.7864C121.057 44.7864 122.825 46.5538 122.825 48.734C122.825 50.9142 121.057 52.6816 118.877 52.6816C116.697 52.6816 114.929 50.9142 114.929 48.734ZM118.877 46.2064C117.481 46.2064 116.349 47.3381 116.349 48.734C116.349 50.1299 117.481 51.2616 118.877 51.2616C120.273 51.2616 121.405 50.1299 121.405 48.734C121.405 47.3381 120.273 46.2064 118.877 46.2064Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.337 51.006C111.729 51.006 112.047 51.3239 112.047 51.716V83.7796C112.047 84.1717 111.729 84.4896 111.337 84.4896C110.945 84.4896 110.627 84.1717 110.627 83.7796V51.716C110.627 51.3239 110.945 51.006 111.337 51.006Z"
      fill="#464950"
    />
    <path
      d="M102.561 83.9074C102.561 79.761 105.927 76.3956 110.073 76.3956C114.219 76.3956 117.585 79.761 117.585 83.9074H102.561Z"
      fill="#72B579"
    />
    <path
      d="M102.561 83.9074C102.561 79.761 105.927 76.3956 110.073 76.3956C114.219 76.3956 117.585 79.761 117.585 83.9074H102.561Z"
      fill="#72B579"
    />
    <path
      opacity="0.38"
      d="M111.394 76.5092C110.968 76.4382 110.527 76.3956 110.073 76.3956C105.927 76.3956 102.561 79.761 102.561 83.9074H105.217C105.217 80.2154 107.872 77.134 111.394 76.5092Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.308 83.1974H116.838C116.483 79.7763 113.588 77.1056 110.073 77.1056C106.558 77.1056 103.663 79.7763 103.308 83.1974ZM101.851 83.9074C101.851 79.3689 105.534 75.6856 110.073 75.6856C114.612 75.6856 118.295 79.3689 118.295 83.9074C118.295 84.2995 117.977 84.6174 117.585 84.6174H102.561C102.169 84.6174 101.851 84.2995 101.851 83.9074Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M116.163 60.6248C116.419 60.9219 116.386 61.3702 116.088 61.6261L111.8 65.3181C111.503 65.5739 111.055 65.5404 110.799 65.2432C110.543 64.9461 110.576 64.4978 110.874 64.2419L115.162 60.5499C115.459 60.2941 115.907 60.3276 116.163 60.6248Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.811 53.8465C107.093 53.5741 107.542 53.5819 107.815 53.8639L111.847 58.0387C112.12 58.3207 112.112 58.7702 111.83 59.0426C111.548 59.3151 111.099 59.3073 110.826 59.0253L106.793 54.8505C106.521 54.5684 106.529 54.119 106.811 53.8465Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.515 66.672C100.779 66.9613 100.76 67.4104 100.47 67.6751L97.7866 70.1317C97.4973 70.3965 97.0482 70.3766 96.7835 70.0874C96.5187 69.7982 96.5386 69.349 96.8278 69.0843L99.5116 66.6277C99.8009 66.3629 100.25 66.3828 100.515 66.672Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.9935 61.9349C94.2708 61.6577 94.7204 61.6577 94.9976 61.9349L97.8092 64.7465C98.0865 65.0238 98.0865 65.4734 97.8092 65.7506C97.532 66.0279 97.0824 66.0279 96.8051 65.7506L93.9935 62.939C93.7163 62.6618 93.7163 62.2122 93.9935 61.9349Z"
      fill="#464950"
    />
    <path
      opacity="0.51"
      d="M100.332 63.6866C100.873 63.6866 101.312 63.248 101.312 62.7068C101.312 62.1656 100.873 61.727 100.332 61.727C99.7906 61.727 99.352 62.1656 99.352 62.7068C99.352 63.248 99.7906 63.6866 100.332 63.6866Z"
      fill="#464950"
    />
    <path
      opacity="0.51"
      d="M94.3678 58.4468C94.6267 58.4468 94.8364 58.2369 94.8364 57.9782C94.8364 57.7193 94.6267 57.5096 94.3678 57.5096C94.1091 57.5096 93.8992 57.7193 93.8992 57.9782C93.8992 58.2369 94.1091 58.4468 94.3678 58.4468Z"
      fill="#464950"
    />
    <path
      opacity="0.43"
      d="M96.9522 55.5216C97.5325 55.5216 98.003 55.0512 98.003 54.4708C98.003 53.8904 97.5325 53.42 96.9522 53.42C96.3718 53.42 95.9014 53.8904 95.9014 54.4708C95.9014 55.0512 96.3718 55.5216 96.9522 55.5216Z"
      fill="#C7CAD1"
    />
    <path
      opacity="0.43"
      d="M111.791 44.19C112.215 44.19 112.558 43.8468 112.558 43.4232C112.558 42.9998 112.215 42.6564 111.791 42.6564C111.368 42.6564 111.024 42.9998 111.024 43.4232C111.024 43.8468 111.368 44.19 111.791 44.19Z"
      fill="#C7CAD1"
    />
    <path
      opacity="0.51"
      d="M113.836 53.278C114.267 53.278 114.617 52.9284 114.617 52.497C114.617 52.0656 114.267 51.716 113.836 51.716C113.405 51.716 113.055 52.0656 113.055 52.497C113.055 52.9284 113.405 53.278 113.836 53.278Z"
      fill="#464950"
    />
    <path
      opacity="0.43"
      d="M109.32 48.6914C109.956 48.6914 110.471 48.1765 110.471 47.5412C110.471 46.9059 109.956 46.391 109.32 46.391C108.685 46.391 108.17 46.9059 108.17 47.5412C108.17 48.1765 108.685 48.6914 109.32 48.6914Z"
      fill="#C7CAD1"
    />
    <path
      opacity="0.43"
      d="M115.441 57.1972C116.045 57.1972 116.534 56.7077 116.534 56.1038C116.534 55.5 116.045 55.0104 115.441 55.0104C114.837 55.0104 114.347 55.5 114.347 56.1038C114.347 56.7077 114.837 57.1972 115.441 57.1972Z"
      fill="#C7CAD1"
    />
    <path
      opacity="0.43"
      d="M99.5366 58.816C99.8974 58.816 100.19 58.5235 100.19 58.1628C100.19 57.802 99.8974 57.5096 99.5366 57.5096C99.1759 57.5096 98.8834 57.802 98.8834 58.1628C98.8834 58.5235 99.1759 58.816 99.5366 58.816Z"
      fill="#C7CAD1"
    />
    <path
      opacity="0.35"
      d="M94.5808 66.0864C94.8475 66.0864 95.0636 65.8703 95.0636 65.6036C95.0636 65.337 94.8475 65.1208 94.5808 65.1208C94.3141 65.1208 94.098 65.337 94.098 65.6036C94.098 65.8703 94.3141 66.0864 94.5808 66.0864Z"
      fill="#C7CAD1"
    />
    <path
      d="M113.183 83.9074C113.183 81.4082 115.213 79.3918 117.698 79.3918C120.183 79.3918 122.214 81.4224 122.214 83.9074H113.183Z"
      fill="#AECC75"
    />
    <path
      opacity="0.51"
      d="M118.92 79.548C118.536 79.4344 118.124 79.3776 117.698 79.3776C115.199 79.3776 113.183 81.4082 113.183 83.8932H115.639C115.625 81.8342 117.017 80.0876 118.92 79.548Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.959 83.1974H121.437C121.102 81.4407 119.549 80.1018 117.698 80.1018C115.845 80.1018 114.292 81.4324 113.959 83.1974ZM112.473 83.9074C112.473 81.0146 114.823 78.6818 117.698 78.6818C120.576 78.6818 122.924 81.0303 122.924 83.9074C122.924 84.2995 122.606 84.6174 122.214 84.6174H113.183C112.791 84.6174 112.473 84.2995 112.473 83.9074Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.978 96.8436C113.978 96.4515 114.296 96.1336 114.688 96.1336H117.5C117.892 96.1336 118.21 96.4515 118.21 96.8436C118.21 97.2357 117.892 97.5536 117.5 97.5536H114.688C114.296 97.5536 113.978 97.2357 113.978 96.8436Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M118.834 96.8436C118.834 96.4515 119.152 96.1336 119.544 96.1336H120.169C120.561 96.1336 120.879 96.4515 120.879 96.8436C120.879 97.2357 120.561 97.5536 120.169 97.5536H119.544C119.152 97.5536 118.834 97.2357 118.834 96.8436Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.733 96.8436C71.733 96.4515 72.0508 96.1336 72.443 96.1336H112.487C112.879 96.1336 113.197 96.4515 113.197 96.8436C113.197 97.2357 112.879 97.5536 112.487 97.5536H72.443C72.0508 97.5536 71.733 97.2357 71.733 96.8436Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.686 96.8436C67.686 96.4515 68.0039 96.1336 68.396 96.1336H69.958C70.3501 96.1336 70.668 96.4515 70.668 96.8436C70.668 97.2357 70.3501 97.5536 69.958 97.5536H68.396C68.0039 97.5536 67.686 97.2357 67.686 96.8436Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.1426 89.417C70.1426 89.1033 70.3969 88.849 70.7106 88.849H111.337C111.65 88.849 111.905 89.1033 111.905 89.417V89.985C111.905 90.2987 111.65 90.553 111.337 90.553H70.7106C70.3969 90.553 70.1426 90.2987 70.1426 89.985V89.417Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.5686 92.7114C70.5686 92.3977 70.8229 92.1434 71.1366 92.1434H111.763C112.077 92.1434 112.331 92.3977 112.331 92.7114V93.7054C112.331 94.0191 112.077 94.2734 111.763 94.2734H71.1366C70.8229 94.2734 70.5686 94.0191 70.5686 93.7054V92.7114Z"
      fill="#464950"
    />
    <path
      d="M75.9078 96.8436H73.2098V86.4776L74.5588 84.9724L75.9078 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M74.4878 87.1876L75.6664 85.8812L74.9848 85.1144L73.6358 86.6196V96.9856H74.4878V87.1876Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.5588 84.2624C74.7605 84.2624 74.9528 84.3483 75.0875 84.4986L76.4365 86.0038C76.5532 86.134 76.6178 86.3027 76.6178 86.4776V96.8436C76.6178 97.2357 76.2999 97.5536 75.9078 97.5536H73.2098C72.8176 97.5536 72.4998 97.2357 72.4998 96.8436V86.4776C72.4998 86.3027 72.5643 86.134 72.681 86.0038L74.03 84.4986C74.1647 84.3483 74.357 84.2624 74.5588 84.2624ZM73.9198 86.7492V96.1336H75.1978V86.7492L74.5588 86.0362L73.9198 86.7492Z"
      fill="#464950"
    />
    <path
      d="M89.483 96.8436H86.785V86.4776L88.134 84.9724L89.483 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M88.063 87.1876L89.2416 85.8812L88.56 85.1144L87.211 86.6196V96.9856H88.063V87.1876Z"
      fill="#A58167"
    />
    <path
      d="M96.2706 96.8436H93.5726V86.4776L94.9216 84.9724L96.2706 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M94.7086 87.0456L95.8872 85.7392L95.2056 84.9724L93.8566 86.4776V96.8436H94.7086V87.0456Z"
      fill="#A58167"
    />
    <path
      d="M82.6954 96.8436H79.9974V86.4776L81.3464 84.9724L82.6954 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M81.2754 87.1876L82.454 85.8812L81.7724 85.1144L80.4234 86.6196V96.9856H81.2754V87.1876Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M88.134 84.2624C88.3358 84.2624 88.528 84.3483 88.6627 84.4986L90.0117 86.0038C90.1284 86.134 90.193 86.3027 90.193 86.4776V96.8436C90.193 97.2357 89.8751 97.5536 89.483 97.5536H86.785C86.3929 97.5536 86.075 97.2357 86.075 96.8436V86.4776C86.075 86.3027 86.1395 86.134 86.2563 86.0038L87.6053 84.4986C87.7399 84.3483 87.9322 84.2624 88.134 84.2624ZM87.495 86.7492V96.1336H88.773V86.7492L88.134 86.0362L87.495 86.7492Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.9216 84.2624C95.1234 84.2624 95.3156 84.3483 95.4503 84.4986L96.7993 86.0038C96.916 86.134 96.9806 86.3027 96.9806 86.4776V96.8436C96.9806 97.2357 96.6627 97.5536 96.2706 97.5536H93.5726C93.1805 97.5536 92.8626 97.2357 92.8626 96.8436V86.4776C92.8626 86.3027 92.9271 86.134 93.0439 86.0038L94.3929 84.4986C94.5275 84.3483 94.7198 84.2624 94.9216 84.2624ZM94.2826 86.7492V96.1336H95.5606V86.7492L94.9216 86.0362L94.2826 86.7492Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M81.3464 84.2624C81.5481 84.2624 81.7404 84.3483 81.8751 84.4986L83.2241 86.0038C83.3408 86.134 83.4054 86.3027 83.4054 86.4776V96.8436C83.4054 97.2357 83.0875 97.5536 82.6954 97.5536H79.9974C79.6052 97.5536 79.2874 97.2357 79.2874 96.8436V86.4776C79.2874 86.3027 79.3519 86.134 79.4686 86.0038L80.8176 84.4986C80.9523 84.3483 81.1446 84.2624 81.3464 84.2624ZM80.7074 86.7492V96.1336H81.9854V86.7492L81.3464 86.0362L80.7074 86.7492Z"
      fill="#464950"
    />
    <path
      d="M109.576 96.8436H106.878V86.4776L108.227 84.9724L109.576 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M108.156 87.1876L109.335 85.8812L108.653 85.1144L107.304 86.6196V96.9856H108.156V87.1876Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M108.227 84.2624C108.429 84.2624 108.621 84.3483 108.756 84.4986L110.105 86.0038C110.221 86.134 110.286 86.3027 110.286 86.4776V96.8436C110.286 97.2357 109.968 97.5536 109.576 97.5536H106.878C106.486 97.5536 106.168 97.2357 106.168 96.8436V86.4776C106.168 86.3027 106.233 86.134 106.349 86.0038L107.698 84.4986C107.833 84.3483 108.025 84.2624 108.227 84.2624ZM107.588 86.7492V96.1336H108.866V86.7492L108.227 86.0362L107.588 86.7492Z"
      fill="#464950"
    />
    <path
      d="M102.987 96.8436H100.289V86.4776L101.638 84.9724L102.987 86.4776V96.8436Z"
      fill="#A58167"
    />
    <path
      opacity="0.47"
      d="M101.567 87.1876L102.746 85.8812L102.064 85.1144L100.715 86.6196V96.9856H101.567V87.1876Z"
      fill="#A58167"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M101.638 84.2624C101.84 84.2624 102.032 84.3483 102.167 84.4986L103.516 86.0038C103.633 86.134 103.697 86.3027 103.697 86.4776V96.8436C103.697 97.2357 103.379 97.5536 102.987 97.5536H100.289C99.897 97.5536 99.5792 97.2357 99.5792 96.8436V86.4776C99.5792 86.3027 99.6437 86.134 99.7604 86.0038L101.109 84.4986C101.244 84.3483 101.436 84.2624 101.638 84.2624ZM100.999 86.7492V96.1336H102.277V86.7492L101.638 86.0362L100.999 86.7492Z"
      fill="#464950"
    />
    <path
      opacity="0.67"
      d="M41.132 52.497C41.4065 52.497 41.629 52.2745 41.629 52C41.629 51.7255 41.4065 51.503 41.132 51.503C40.8575 51.503 40.635 51.7255 40.635 52C40.635 52.2745 40.8575 52.497 41.132 52.497Z"
      fill="#464950"
    />
    <path
      opacity="0.76"
      d="M38.363 53.8886C38.8179 53.8886 39.1866 53.5198 39.1866 53.065C39.1866 52.6102 38.8179 52.2414 38.363 52.2414C37.9082 52.2414 37.5394 52.6102 37.5394 53.065C37.5394 53.5198 37.9082 53.8886 38.363 53.8886Z"
      fill="#464950"
    />
    <path
      opacity="0.43"
      d="M82.7806 77.8866C83.1178 77.8866 83.3912 77.6133 83.3912 77.276C83.3912 76.9388 83.1178 76.6654 82.7806 76.6654C82.4433 76.6654 82.17 76.9388 82.17 77.276C82.17 77.6133 82.4433 77.8866 82.7806 77.8866Z"
      fill="#C7CAD1"
    />
    <path
      opacity="0.51"
      d="M81.0766 76.0406C81.3511 76.0406 81.5736 75.8181 81.5736 75.5436C81.5736 75.2691 81.3511 75.0466 81.0766 75.0466C80.8021 75.0466 80.5796 75.2691 80.5796 75.5436C80.5796 75.8181 80.8021 76.0406 81.0766 76.0406Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.562622 84.092C0.562622 83.6999 0.8805 83.382 1.27262 83.382H126.275C126.667 83.382 126.985 83.6999 126.985 84.092C126.985 84.4841 126.667 84.802 126.275 84.802H1.27262C0.8805 84.802 0.562622 84.4841 0.562622 84.092Z"
      fill="#464950"
    />
    <path
      d="M93.6152 83.9784C93.5868 83.7654 93.5868 83.5524 93.6152 83.3252C93.7998 81.678 95.2766 80.4852 96.9238 80.6556C98.571 80.8402 99.7638 82.317 99.5934 83.9642L93.6152 83.9784Z"
      fill="#AECC75"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.3403 83.2667L98.8651 83.2559C98.6927 82.2734 97.89 81.4797 96.8478 81.3615C95.637 81.2378 94.5452 82.0785 94.3403 83.2667ZM92.9101 83.2416C93.1402 81.2107 94.9621 79.7389 96.9969 79.9494L97.0029 79.95C99.0361 80.1779 100.51 82.001 100.3 84.0372C100.262 84.3985 99.9583 84.6733 99.5951 84.6742L93.6169 84.6884C93.2604 84.6892 92.9586 84.4256 92.9114 84.0722C92.8747 83.7965 92.8752 83.5237 92.9101 83.2416Z"
      fill="#464950"
    />
    <path
      d="M89.8096 84.163C89.7954 84.092 89.7954 84.0352 89.7954 83.9642C89.7954 83.0554 90.5338 82.317 91.4426 82.317C92.3514 82.317 93.0898 83.0554 93.0898 83.9642C93.0898 84.0494 93.0898 84.1346 93.0756 84.2056L89.8096 84.163Z"
      fill="#464950"
    />
    <path
      d="M76.1918 84.0636C76.1776 83.9642 76.1776 83.879 76.1776 83.7796C76.1776 82.4306 77.271 81.3372 78.62 81.3372C79.969 81.3372 81.0624 82.4306 81.0624 83.7796C81.0624 83.9074 81.0482 84.021 81.034 84.1488L76.1918 84.0636Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.8647 11.6091C92.6137 10.2976 94.0257 9.4142 95.6458 9.4142C96.0379 9.4142 96.3558 9.73208 96.3558 10.1242C96.3558 10.5163 96.0379 10.8342 95.6458 10.8342C94.2515 10.8342 93.0851 11.8054 92.788 13.1079C92.7244 13.3869 92.4994 13.6005 92.2174 13.6495C91.9354 13.6985 91.6516 13.5734 91.4975 13.3323C90.9698 12.5062 90.0552 11.9702 89.0144 11.9702C88.568 11.9702 88.1343 12.0736 87.7622 12.2541C87.4093 12.4251 86.9846 12.2778 86.8135 11.925C86.6425 11.5721 86.7898 11.1474 87.1427 10.9763C87.7077 10.7024 88.3532 10.5502 89.0144 10.5502C90.103 10.5502 91.099 10.9475 91.8647 11.6091Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.8384 15.4971C99.4573 14.5531 100.524 13.9298 101.738 13.9298C102.13 13.9298 102.448 14.2477 102.448 14.6398C102.448 15.0319 102.13 15.3498 101.738 15.3498C100.769 15.3498 99.9563 16.0235 99.7453 16.9306C99.6804 17.2097 99.4542 17.4224 99.1716 17.47C98.8891 17.5175 98.6056 17.3906 98.453 17.1481C98.0956 16.5804 97.4523 16.2018 96.7392 16.2018C96.4256 16.2018 96.1326 16.2746 95.8678 16.4017C95.5143 16.5714 95.0902 16.4223 94.9205 16.0688C94.7508 15.7153 94.8999 15.2912 95.2534 15.1215C95.6986 14.9078 96.2008 14.7818 96.7392 14.7818C97.5238 14.7818 98.2549 15.0489 98.8384 15.4971Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9525 18.4316C17.9994 18.8209 17.7217 19.1745 17.3324 19.2213C15.799 19.4058 14.6206 20.7091 14.6206 22.2936C14.6206 22.3973 14.6216 22.4346 14.6277 22.4772C14.6568 22.6809 14.5961 22.8873 14.4612 23.0428C14.3263 23.1983 14.1307 23.2876 13.9248 23.2876H10.602C10.2099 23.2876 9.89203 22.9697 9.89203 22.5776C9.89203 22.1855 10.2099 21.8676 10.602 21.8676H13.2203C13.4167 19.7562 15.0588 18.0646 17.1628 17.8115C17.5521 17.7647 17.9057 18.0423 17.9525 18.4316Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.53 14.1712C20.07 14.1712 18.0552 16.1151 17.957 18.5451C17.9412 18.9369 17.6107 19.2417 17.2189 19.2258C16.8271 19.21 16.5224 18.8795 16.5382 18.4877C16.6672 15.2945 19.31 12.7512 22.53 12.7512C25.4784 12.7512 27.9267 14.878 28.4262 17.6819C28.495 18.0679 28.2378 18.4366 27.8517 18.5054C27.4657 18.5742 27.097 18.317 27.0282 17.9309C26.6474 15.7932 24.7788 14.1712 22.53 14.1712Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0904 18.3034C27.9085 18.3034 26.8366 18.8219 26.1154 19.6394C25.8559 19.9334 25.4073 19.9614 25.1132 19.702C24.8192 19.4426 24.7912 18.9939 25.0506 18.6999C26.0333 17.5861 27.489 16.8834 29.0904 16.8834C31.9236 16.8834 34.252 19.0754 34.4698 21.8534H38.4766C38.8687 21.8534 39.1866 22.1713 39.1866 22.5634C39.1866 22.9555 38.8687 23.2734 38.4766 23.2734H33.7622C33.5564 23.2734 33.3607 23.1841 33.2258 23.0286C33.091 22.8731 33.0302 22.6668 33.0593 22.463C33.0654 22.4204 33.0664 22.3831 33.0664 22.2794C33.0664 20.0871 31.2827 18.3034 29.0904 18.3034Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M117.448 5.09921C117.494 4.7098 117.847 4.43146 118.236 4.47752C119.746 4.6561 120.93 5.82681 121.154 7.3126H122.782C123.174 7.3126 123.492 7.63048 123.492 8.0226C123.492 8.41473 123.174 8.7326 122.782 8.7326H120.467C120.255 8.7326 120.053 8.63723 119.918 8.47274C119.784 8.3087 119.73 8.09315 119.771 7.88511C119.771 7.88479 119.771 7.88437 119.771 7.88384C119.771 7.8808 119.771 7.87531 119.771 7.86525C119.772 7.85448 119.772 7.84252 119.772 7.8238C119.772 6.81912 119.031 6.00146 118.069 5.88769C117.68 5.84163 117.402 5.48861 117.448 5.09921Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.127 4.5596C110.499 2.49591 112.293 0.936798 114.461 0.936798C116.83 0.936798 118.761 2.79977 118.862 5.15198C118.879 5.54374 118.575 5.87503 118.183 5.89194C117.792 5.90885 117.46 5.60498 117.443 5.21322C117.375 3.61783 116.067 2.3568 114.461 2.3568C112.994 2.3568 111.777 3.41048 111.524 4.8116C111.455 5.1975 111.085 5.45392 110.7 5.38433C110.314 5.31474 110.057 4.9455 110.127 4.5596Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.916 7.3126C106.168 5.34433 107.853 3.8336 109.874 3.8336C111.05 3.8336 112.121 4.35211 112.846 5.16391C113.107 5.4563 113.082 5.90514 112.79 6.16642C112.497 6.4277 112.048 6.40249 111.787 6.1101C111.32 5.5871 110.629 5.2536 109.874 5.2536C108.461 5.2536 107.304 6.40032 107.304 7.8238V8.0226C107.304 8.41473 106.986 8.7326 106.594 8.7326H103.3C102.907 8.7326 102.59 8.41473 102.59 8.0226C102.59 7.63048 102.907 7.3126 103.3 7.3126H105.916Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.015 37.232C96.015 36.8399 96.3329 36.522 96.725 36.522H102.007C102.4 36.522 102.717 36.8399 102.717 37.232C102.717 37.6241 102.4 37.942 102.007 37.942H96.725C96.3329 37.942 96.015 37.6241 96.015 37.232Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.0106 37.232C92.0106 36.8399 92.3285 36.522 92.7206 36.522H93.9134C94.3055 36.522 94.6234 36.8399 94.6234 37.232C94.6234 37.6241 94.3055 37.942 93.9134 37.942H92.7206C92.3285 37.942 92.0106 37.6241 92.0106 37.232Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M101.028 41.0376C101.028 40.6455 101.345 40.3276 101.738 40.3276H110.882C111.275 40.3276 111.592 40.6455 111.592 41.0376C111.592 41.4297 111.275 41.7476 110.882 41.7476H101.738C101.345 41.7476 101.028 41.4297 101.028 41.0376Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.7534 41.0376C96.7534 40.6455 97.0713 40.3276 97.4634 40.3276H99.3662C99.7583 40.3276 100.076 40.6455 100.076 41.0376C100.076 41.4297 99.7583 41.7476 99.3662 41.7476H97.4634C97.0713 41.7476 96.7534 41.4297 96.7534 41.0376Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.3666 44.0906C80.3666 43.6985 80.6845 43.3806 81.0766 43.3806H89.0428C89.4349 43.3806 89.7528 43.6985 89.7528 44.0906C89.7528 44.4827 89.4349 44.8006 89.0428 44.8006H81.0766C80.6845 44.8006 80.3666 44.4827 80.3666 44.0906Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.0952 41.0376C85.0952 40.6455 85.4131 40.3276 85.8052 40.3276H92.1526C92.5447 40.3276 92.8626 40.6455 92.8626 41.0376C92.8626 41.4297 92.5447 41.7476 92.1526 41.7476H85.8052C85.4131 41.7476 85.0952 41.4297 85.0952 41.0376Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.2894 36.6072C55.2894 36.2151 55.6073 35.8972 55.9994 35.8972H62.361C62.7531 35.8972 63.071 36.2151 63.071 36.6072C63.071 36.9993 62.7531 37.3172 62.361 37.3172H55.9994C55.6073 37.3172 55.2894 36.9993 55.2894 36.6072Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.651 41.0376C61.651 40.6455 61.9689 40.3276 62.361 40.3276H65.5418C65.9339 40.3276 66.2518 40.6455 66.2518 41.0376C66.2518 41.4297 65.9339 41.7476 65.5418 41.7476H62.361C61.9689 41.7476 61.651 41.4297 61.651 41.0376Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.108215 34.1364C0.108215 33.7443 0.426093 33.4264 0.818215 33.4264H8.2732C8.66532 33.4264 8.9832 33.7443 8.9832 34.1364C8.9832 34.5285 8.66532 34.8464 8.2732 34.8464H0.818215C0.426093 34.8464 0.108215 34.5285 0.108215 34.1364Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M101.965 33.824C101.221 33.824 100.616 34.4291 100.616 35.173C100.616 35.5651 100.298 35.883 99.9058 35.883C99.5137 35.883 99.1958 35.5651 99.1958 35.173C99.1958 33.6449 100.437 32.404 101.965 32.404C103.493 32.404 104.734 33.6449 104.734 35.173C104.734 36.7011 103.493 37.942 101.965 37.942C101.573 37.942 101.255 37.6241 101.255 37.232C101.255 36.8399 101.573 36.522 101.965 36.522C102.709 36.522 103.314 35.9169 103.314 35.173C103.314 34.4291 102.709 33.824 101.965 33.824Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M88.3186 44.1048C88.3186 43.7127 88.6365 43.3948 89.0286 43.3948C90.3721 43.3948 91.4568 44.4795 91.4568 45.823C91.4568 47.1665 90.3721 48.2512 89.0286 48.2512C87.6851 48.2512 86.6004 47.1665 86.6004 45.823C86.6004 45.4309 86.9183 45.113 87.3104 45.113C87.7025 45.113 88.0204 45.4309 88.0204 45.823C88.0204 46.3823 88.4693 46.8312 89.0286 46.8312C89.5879 46.8312 90.0368 46.3823 90.0368 45.823C90.0368 45.2637 89.5879 44.8148 89.0286 44.8148C88.6365 44.8148 88.3186 44.4969 88.3186 44.1048Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2896 37.232C10.2896 36.8399 10.6075 36.522 10.9996 36.522H14.5496C14.9417 36.522 15.2596 36.8399 15.2596 37.232C15.2596 37.6241 14.9417 37.942 14.5496 37.942H10.9996C10.6075 37.942 10.2896 37.6241 10.2896 37.232Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.42499 37.232C4.42499 36.8399 4.74287 36.522 5.13499 36.522H8.27319C8.66531 36.522 8.98319 36.8399 8.98319 37.232C8.98319 37.6241 8.66531 37.942 8.27319 37.942H5.13499C4.74287 37.942 4.42499 37.6241 4.42499 37.232Z"
      fill="#464950"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.507 33.824C13.7631 33.824 13.158 34.4291 13.158 35.173C13.158 35.5651 12.8401 35.883 12.448 35.883C12.0559 35.883 11.738 35.5651 11.738 35.173C11.738 33.6449 12.9789 32.404 14.507 32.404C16.0351 32.404 17.276 33.6449 17.276 35.173C17.276 36.7011 16.0351 37.942 14.507 37.942C14.1149 37.942 13.797 37.6241 13.797 37.232C13.797 36.8399 14.1149 36.522 14.507 36.522C15.2509 36.522 15.856 35.9169 15.856 35.173C15.856 34.4291 15.2509 33.824 14.507 33.824Z"
      fill="#464950"
    />
  </svg>
);
